import React from "react";
import dynamic from 'next/dynamic'
const Carousel = dynamic(() => import('react-multi-carousel'), { 
  ssr: false 
})
import Image from "next/image";
import RightArrowBottom from "./RightArrowBottom";
import LeftArrowBottom from "./LeftArrowBottom";
import "react-multi-carousel/lib/styles.css";
import { urlForImage } from '~/lib/sanity.image';

const responsive = {
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 3,
    slidesToSlide: 3 // optional, default to 1.
  },
  tablet: {
    breakpoint: { max: 1024, min: 768 },
    items: 2,
    slidesToSlide: 1 // optional, default to 1.
  },
  mobile: {
    breakpoint: { max: 767, min: 375 },
    items: 1,
    slidesToSlide: 1 // optional, default to 1.
  }
};
const SliderMulti = ({items, imageOnly = false, prefix = '/systems/'}) => {
  return (
    <div className="parent">
        
      <Carousel
        responsive={responsive}
        autoPlay={false}
        swipeable={true}
        draggable={true}
        showDots={true}
        infinite={true}
        partialVisible={false}
        renderButtonGroupOutside={true}
        customLeftArrow={<LeftArrowBottom/>}
        customRightArrow={<RightArrowBottom />} 
        containerClass="spacer-carousel-container"
        dotListClass="spacer-custom-dot-list-style"
      >
        {items && (
          items.map((item, index) => {
            let slide = item.image
            if(item.smallImage) {
              slide = item.smallImage
            }
            
  
            return (
              <div className="slider slider-margin" key={index}>
                <div className="imageWrapper">
                  {slide && (
                    <>
                        <Image
                          key={slide._id}
                          src={urlForImage(slide).url()}
                          alt={slide.title ? slide.title : "slider"}
                          width={0}
                          height={0}
                          sizes="100vw"
                          style={{ width: '100%', height: 'auto' }} 
                          className="h-full w-full object-cover"
                        />
                        <span className="absolute bottom-4 left-4 w-full flex">
                          <h2 className="text-xl text-background w-32">{slide.title}</h2>
                      </span>
                      </>
                  )}                  
                </div>
                {!imageOnly && (
                  <>
                  <h3 className="text-2xl font-semibold text-primary mt-10 mb-5">{item.title}</h3>
                  <p className="text-xl text-primary">{item.excerpt}</p> 
                  { item.slug && (
                    <a className="mt-2 font-bold underline float-end" href={prefix + item.slug.current}>More</a>
                  )}                                 
                  </>
                )}
                
                
              </div>              
            );
          })
        )}
      </Carousel>
    </div>
  );
};
export default SliderMulti;
